module.exports = __webpack_public_path__ + "img/05blue.7c0e2997.gif";